import { isRtlLanguage } from "@/i18n";

export default {
  getLocale: state => state.locale,
  isRtl: state => isRtlLanguage(state.locale)
}
